/**
 * The market a Source Intelligence run stands for, picked from the study's
 * fixed labels rather than typed: a hand-typed spelling ("Western
 * Blotting/Protein Detection") would pool as a new market (2026-10-21).
 */
import { SOURCE_INTELLIGENCE_MARKETS } from '@aurora/shared';

export function MarketSelect({
  id,
  value,
  onChange,
}: {
  id: string;
  value: string;
  onChange: (market: string) => void;
}) {
  const known = (SOURCE_INTELLIGENCE_MARKETS as readonly string[]).includes(value);
  return (
    <select id={id} value={value} onChange={(e) => onChange(e.target.value)}>
      <option value="">Choose a market…</option>
      {/* A stored label from before the list existed stays visible until changed. */}
      {value && !known && (
        <option value={value}>{value} (not a study label — choose one)</option>
      )}
      {SOURCE_INTELLIGENCE_MARKETS.map((m) => (
        <option key={m} value={m}>
          {m}
        </option>
      ))}
    </select>
  );
}
